import React, { Component } from 'react';
import ReactDropzone from 'react-dropzone';
import request from 'superagent';
import { BASE_URL } from '../config';
import {token} from "../libs/localStorage";
import Spinner from "./Spinner";

export default class Dropzone extends Component {
  constructor(props) {
    super(props);
    this.state = {
      files: [],
      uploading: null,
    };

    this.onOpenClick = this.onOpenClick.bind(this);
    this.onDrop = this.onDrop.bind(this);
  }

  onOpenClick() {
    this.refs.dropzone.open();
  }

  onDrop(files) {
    const { destination } = this.props;
    const url = `${BASE_URL}${destination}`;
    this.setState({
      files,
      uploading: true,
    });
    const req = request
      .post(url)
      .set('Authorization', `Bearer ${token.getEncoded()}`);

    files.forEach(file => {
      // req.attach(file.name, file);
      req.attach('photo', file);
    });
    req.end((a, b) => {
      console.log('req.end', a, b);
      this.setState({uploading: false});
      const { id, resetImages, context } = this.props;
      resetImages(id, context);
      context.context.notify.success({message:b.text});
    })
  }

  render() {
    const { files, uploading } = this.state;

    return (
      <div>
        <ReactDropzone ref="dropzone" onDrop={this.onDrop} style={{ display: 'none' }}>
          <div>Try dropping a file here, or click to select a file to upload.</div>
        </ReactDropzone>
        {uploading && <Spinner/>}
        {this.state.files ?
          <div>
            {/*<div>*/}
              {/*{this.state.files.map((file) => (*/}
                {/*<img key={file.lastModified} src={file.preview} style={{ width: '20%' }} />*/}
              {/*))}*/}
            {/*</div>*/}
          </div> : null
        }
        <button type="button" className="button small" onClick={this.onOpenClick}>
          Add Picture
        </button>
      </div>
    );
  }
}




// WEBPACK FOOTER //
// ./src/components/Dropzone.js